<template>
  <steps-screen
    class="redeem-integration"
    :step="stepperCurrentStep"
  >
    <redeem-stepper slot="stepper" :currentStep="stepperCurrentStep" />
    <sky-redeem-step
      v-if="!redeemed"
      @subscriptionCreated="redeemed = true"
    />
    <sky-success-step v-else />
  </steps-screen>
</template>

<script>
export default {
  name: 'redeem-integration',
  data: () => ({
    redeemed: false
  }),
  computed: {
    stepperCurrentStep() {
      return this.redeemed ? 2 : 1
    }
  }
}
</script>

<style lang="scss">
</style>
